<script setup>

</script>

<template>

  <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.5827 5.13397C10.2494 5.51887 10.2494 6.48113 9.5827 6.86603L2.20676 11.1245C1.54009 11.5094 0.706756 11.0283 0.706756 10.2585L0.706756 1.7415C0.706757 0.971695 1.54009 0.49057 2.20676 0.87547L9.5827 5.13397Z" fill="white"/>
  </svg>




</template>

<style scoped lang="scss">

</style>